import React, { createContext, useContext, useEffect } from "react";
// import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { signIn, signOut } from "src/redux/AuthSlice";
import { useHttpRequest } from "./HttpRequest";
import { useLocalStorage } from "./useLocalStorage";
import { HTTP_METHODS } from "src/config/constants";
import apiBase from "src/config/apiBase";
import axios from "axios";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const { isLoading, error, sendRequest, clearError } = useHttpRequest();
  const [user, setUser] = useLocalStorage("user", null);

  const dispatch = useDispatch();
  // const navigate = useNavigate();
  // const token = "eyJhbGciOiJIUzI1NiJ9.eyJwcmluY2lwbGUiOiJ7XCJ1c2VybmFtZVwiOlwiamFzb25jaGFuXCIsXCJ1c2VySWRcIjpcImJjMTA0YzQ3LWEzYWYtNGYzMS1iMWM1LTZhMjQ1ZjA3ZjdkMFwiLFwiY29tcGFueUNvZGVcIjpudWxsfSIsInJvbGUiOiJTWVNURU1fQURNSU4iLCJzdWIiOiJqYXNvbmNoYW4iLCJpYXQiOjE2OTE0MjE3NjcsImV4cCI6MTc3NzczNTM2N30.FCg-jQXv4ytauuCuAhcuMAC4G-ySMIYrWFihz6j3VM0"
  // const token = localStorage.getItem("token");
  const appStartUpHandler = async () => {
    if (user != null) {
      const lastLoginDate = new Date(user.lastLogin);
      const currentDate = new Date();
      const timeDiff = currentDate.getTime() - lastLoginDate.getTime();
      const dateDiff = Math.floor(timeDiff / (1000 * 3600 * 24));
      if (dateDiff > 30) {
        console.log("Logout");
        dispatch(signOut());
        apiBase.defaults.headers.authorization = null;
        setUser(null);
      } else {
        console.log("Update last login");
        const tmpUser = user;
        tmpUser.lastLogin = new Date();
        dispatch(signIn(tmpUser));
        apiBase.defaults.headers.authorization = `Bearer ${user?.token}`;
        // apiBase.defaults.headers.authorization = `Bearer ${token}`
        setUser(tmpUser);
      }
    }
  };
  const signInHandler = async (username, password) => {
    const requestBody = {
      // username: 'recday1admin',
      // password: '112233',
      username: username,
      password: password,
    };
    const headers = {
      "Content-Type": "application/json",
    };

    const responseData = await sendRequest(
      `/auth/login`,
      HTTP_METHODS.POST,
      headers,
      requestBody
    )

    // const responseData = await axios.post(
    //   `${apiBase.defaults.baseURL}/auth/login`,
    //   params,
    //   headers
    // );
    return responseData;
  };

  const onSignInSuccess = (userData) => {
    userData.lastLogin = new Date();
    dispatch(signIn(userData));
    apiBase.defaults.headers.authorization = `Bearer ${userData.token}`;
    setUser(userData);
  };

  const signOutHandler = async (data) => {
    dispatch(signOut());
    apiBase.defaults.headers.authorization = null;
    setUser(null);
  };

  useEffect(() => {
    appStartUpHandler();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        isLoading,
        error,
        clearError,
        signInHandler,
        onSignInSuccess,
        signOutHandler,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => {
  const authContext = useContext(AuthContext);
  return authContext;
};

export { AuthProvider, useAuth };
